type Props = {
  size?: '16' | '20';
};

const IconDown = ({ size = '16' }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6L7.85858 9.85858C7.93668 9.93668 8.06332 9.93668 8.14142 9.85858L12 6"
        stroke="#878787"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default IconDown;
